import {apiClient} from '../apiClient';
import {
  IngestionListResponse,
  IngestionStateResponse,
  IngestionListRequest,
  IngestionDetailsRequest,
  IngestionDetailsType,
  IIngestionViewWizard,
  IFoldersData,
  AnalyticsResponse,
  AnalyticsInfoResponse,
  IngestionDetailPropsType,
  ESIndexingInfoResponse,
  ESIndexingListResponse,
  IIngestionHeaderResponse,
  IIngestionMappingPayload,
  IMappingResponse,
  IIngestionPreviewPayload,
  IIngestionPreviewResponse,
  IIngestionSaveDraftPayload,
  IIngestionSaveDraftResponse,
  IRunIngestionResponse,
  RollbackIngestionRequest,
  IndexErrorsGridReqPayloadType,
  IndexErrorsGridResponse,
  PaginationReqPayloadType,
  IngestionErrorsModelResponse,
  IngestionErrorsModelPayload,
  IngestionErrorsUpdateModelResponse,
  IngestionErrorsUpdateModelpayLoad,
  IngestionErrorsExportPayload,
  IngestionErrorsIgnoreAllPayload,
  IngestionErrorsIgnoreAllResponse,
  IngestionUnpublishViewResponse,
  IngestionUnpublishHistoryReqPayload,
  IngestionUnpublishHistoryResponse,
  IngestionDatasetResponse,
  ICEDataSetTilePageResponse,
  ICEDatasetTilePageReqPayload,
  IngestionErrorsIgnoreAllRequestPayload,
  IIngestionCopyRequest,
  IIngestionCopyResponse,
  IApoListResponse,
  IApoListRequest,
  IApoProgressApiResponse,
} from '../../api/types/ingestionApi.type';
import {
  BackendErrorData,
  parseApiError,
} from '../../utils/custom-errors/parseApiError';
import {AxiosError} from 'axios';
import BASE_URL from '../../config/env';

const ingestionEndpoint = (path: string) =>
  `${BASE_URL}/ingestions/api/v1/${path}`;

export const getIngestionData = async (): Promise<IngestionStateResponse> => {
  const {data} = await apiClient.get<IngestionStateResponse>(
    ingestionEndpoint('ingestion/view/home')
  );
  return data;
};

export const getIngestionListData = async (
  payload: IngestionListRequest
): Promise<IngestionListResponse> => {
  const {data} = await apiClient.get<IngestionListResponse>(
    ingestionEndpoint('ingestion/view/list'),
    {
      params: payload,
    }
  );
  return data;
};

export const getIngestionDetails = async (
  payload: IngestionDetailsRequest
): Promise<IngestionDetailsType> => {
  const {data} = await apiClient.get<IngestionDetailsType>(
    ingestionEndpoint('ingestion/detail'),
    {
      params: payload,
    }
  );
  return data;
};

//Ingestion Errors

export const postIngestionErrors = async (
  payload: IngestionErrorsModelPayload
): Promise<IngestionErrorsModelResponse> => {
  const {data} = await apiClient.post<IngestionErrorsModelResponse>(
    ingestionEndpoint('ingestion/errors/list'),
    payload
  );
  return data;
};

export const postIngestionIgnoreAll = async (
  payload: IngestionErrorsIgnoreAllPayload
): Promise<IngestionErrorsIgnoreAllResponse> => {
  const {data} =
    await apiClient.post<IngestionErrorsIgnoreAllResponse>(
      ingestionEndpoint('ingestion/view/errors'),
      payload
    );
  return data;
};

export const postIngestionErrorsupdate = async (
  payload: IngestionErrorsUpdateModelpayLoad
): Promise<IngestionErrorsUpdateModelResponse> => {
  const {data} =
    await apiClient.post<IngestionErrorsUpdateModelResponse>(
      ingestionEndpoint('ingestion/errors/update'),
      payload
    );
  return data;
};

export const postIgnoreAllIngestions = async (
  payload: IngestionErrorsIgnoreAllRequestPayload
): Promise<IngestionErrorsIgnoreAllResponse> => {
  const {data} =
    await apiClient.post<IngestionErrorsIgnoreAllResponse>(
      ingestionEndpoint('ingestion/errors/ignore'),
      payload
    );
  return data;
};

export const fetchExportIngestionErrors = async (
  payload: IngestionErrorsExportPayload
): Promise<IngestionErrorsExportPayload> => {
  const {data} = await apiClient.get<IngestionErrorsExportPayload>(
    ingestionEndpoint('ingestion/report/errors/data'),
    {params: payload}
  );
  return data;
};

//end Ingestion Errors

export const postIngestionReRun = async (payload: IngestionDetailPropsType) => {
  const payloadData = {...payload, selectedView: 'INGESTION', isReRun: true};
  const {data} = await apiClient.post<any>(
    ingestionEndpoint('ingestion/rerun'),
    payloadData
  );
  return data;
};

export const postIngestionCopying = async (
  payload: IngestionDetailPropsType
) => {
  const payloadData = {...payload, selectedView: 'INGESTION'};
  const {data} = await apiClient.post<any>(
    ingestionEndpoint('ingestion/copying'),
    payloadData
  );
  return data;
};

export interface IIngestionSummaryResponse {
  success: string;
}

export const getIngestionSummary =
  async (): Promise<IIngestionSummaryResponse> => {
    const {data} = await apiClient.get<IIngestionSummaryResponse>(
      ingestionEndpoint('ingestion/summary')
    );
    return data;
  };

export const getIngestionViewWizard = async () => {
  const {data} = await apiClient.get<IIngestionViewWizard>(
    ingestionEndpoint('ingestion/view/wizard')
  );
  return data;
};

export const postIngestionSourceFolders = async (payload: {
  serverLocation: string;
  serverLocationDetails: Array<{text: string; value: string}>;
}) => {
  const {data} = await apiClient.post<any>(
    ingestionEndpoint('ingestion/source/folders'),
    payload
  );
  return data;
};

export const postIngestionSourceFolderData = async (payload: any) => {
  const {data} = await apiClient.post<IFoldersData>(
    ingestionEndpoint('ingestion/source/folder-data'),
    payload
  );
  return data;
};

export const postIngestionSourceHeaders = async (payload: any) => {
  const {data} = await apiClient.post<IIngestionHeaderResponse>(
    ingestionEndpoint('ingestion/source/headers'),
    payload
  );
  return data;
};

export const fetchIngestionsAnalytics = async (
  payload: any
): Promise<AnalyticsResponse> => {
  const {data} = await apiClient.post<AnalyticsResponse>(
    ingestionEndpoint('ingestion/analytics/list'),
    payload
  );
  return data;
};
export const fetchAnalyticsInfo = async (): Promise<AnalyticsInfoResponse> => {
  const {data} = await apiClient.get<AnalyticsInfoResponse>(
    ingestionEndpoint('ingestion/analyticsinfo')
  );
  return data;
};
export const executeRunIngestionAnalytics = async (payload: {
  selectedValue: string;
}): Promise<object> => {
  const {data} = await apiClient.post<any>(
    ingestionEndpoint(
      'ingestion/run-analytics?selectedValue=' + payload.selectedValue
    )
  );
  return data;
};

export const postIngestionMapping = async (
  payload: IIngestionMappingPayload
): Promise<IMappingResponse> => {
  const {data} = await apiClient.post<IMappingResponse>(
    ingestionEndpoint('ingestion/mapping'),
    payload
  );
  return data;
};

export const postIngestionPreview = async (
  payload: IIngestionPreviewPayload
): Promise<IIngestionPreviewResponse> => {
  const {data} = await apiClient.post<IIngestionPreviewResponse>(
    ingestionEndpoint('ingestion/preview'),
    payload
  );
  return data;
};

export const postIngestionSaveDraft = async (
  payload: IIngestionSaveDraftPayload
): Promise<IIngestionSaveDraftResponse> => {
  const {data} = await apiClient.post<IIngestionSaveDraftResponse>(
    ingestionEndpoint('ingestion/templates'),
    payload
  );
  return data;
};

export const postIngestionRun = async (
  ingestionId: number
): Promise<IRunIngestionResponse> => {
  const {data} = await apiClient.post<IRunIngestionResponse>(
    ingestionEndpoint(`ingestion/run?ingestionId=${ingestionId}`)
  );
  return data;
};
export const rollbackIngestion = async (
  payload: RollbackIngestionRequest
): Promise<string> => {
  const response = await apiClient.post(
    ingestionEndpoint(`ingestion/rollback`),
    payload,
    {}
  );
  return response.data;
};

export const deleteIngestion = async (
  params: RollbackIngestionRequest
): Promise<string> => {
  const {projectId, ingestionId} = params;
  const response = await apiClient.delete(
    ingestionEndpoint(
      `ingestion/delete?projectId=${projectId}&ingestionId=${ingestionId}`
    )
  );
  return response.data;
};

export const approveIngestion = async (
  params: RollbackIngestionRequest
): Promise<string> => {
  const {projectId, ingestionId} = params;

  const response = await apiClient.post(
    ingestionEndpoint(
      `ingestion/approve?projectId=${projectId}&ingestionId=${ingestionId}`
    )
  );
  return response.data;
};

export const fetchESIndexingInfo =
  async (): Promise<ESIndexingInfoResponse> => {
    const {data} = await apiClient.get<ESIndexingInfoResponse>(
      ingestionEndpoint('ingestion/esindexing')
    );
    return data;
  };

export const fetchESIndexingList = async (
  payload: PaginationReqPayloadType
): Promise<ESIndexingListResponse> => {
  const {data} = await apiClient.post<ESIndexingListResponse>(
    ingestionEndpoint('ingestion/indexing/list'),
    payload
  );
  return data;
};

export const fetchIndexErrorsGrid = async (
  payload: IndexErrorsGridReqPayloadType
): Promise<IndexErrorsGridResponse> => {
  const {data} = await apiClient.post<IndexErrorsGridResponse>(
    ingestionEndpoint('ingestion/index-errors/grid'),
    payload
  );
  return data;
};

export const exportIndexingErrorData = async (payload: {
  analyticsId: number;
}): Promise<object> => {
  const {data} = await apiClient.get(
    ingestionEndpoint('ingestion/report/indexing-errors/data'),
    {
      params: payload,
    }
  );
  return data;
};

export const runESIndexing = async (payload: {
  selectedValue: string;
}): Promise<object> => {
  const {data} = await apiClient.post(
    ingestionEndpoint('ingestion/run-esindexing'),
    payload
  );
  return data;
};

export const fetchIngestionSearchTreeViewData =
  async (): Promise<IngestionUnpublishViewResponse> => {
    const {data} = await apiClient.get(
      ingestionEndpoint('ingestion/unpublish/view')
    );
    return data;
  };

export const fetchUnpublishHistoryData = async (
  payload: IngestionUnpublishHistoryReqPayload
): Promise<IngestionUnpublishHistoryResponse> => {
  try {
    const {data} = await apiClient.post(
      ingestionEndpoint('ingestion/unpublish/history'),
      payload
    );
    return data;
  } catch (error) {
    throw parseApiError(error as AxiosError<BackendErrorData>, 'Ingestion');
  }
};

export const unpublishIngestion = async (payload: {
  analyzingSearchId: string;
}): Promise<{message: string; code: number}> => {
  try {
    const {data} = await apiClient.post(
      ingestionEndpoint('ingestion/unpublish/analyze'),
      payload
    );
    return data;
  } catch (error) {
    throw parseApiError(error as AxiosError<BackendErrorData>, 'Ingestion');
  }
};

export const exportUnpublishedDocData = async (payload: {
  analyzingSearchId: string;
}): Promise<{message: string}> => {
  const {data} = await apiClient.get(
    ingestionEndpoint('ingestion/unpublish/doc-ids'),
    {
      params: payload,
    }
  );
  return data;
};

export const getIngestionDataSets =
  async (): Promise<IngestionDatasetResponse> => {
    const {data} = await apiClient.get<IngestionDatasetResponse>(
      ingestionEndpoint('ice/datasets')
    );
    return data;
  };

export const getICEDataSetTitlePage = async (
  payload: ICEDatasetTilePageReqPayload
): Promise<ICEDataSetTilePageResponse> => {
  const {data} = await apiClient.post<ICEDataSetTilePageResponse>(
    ingestionEndpoint('icedataset/gettilepage'),
    payload
  );
  return data;
};

export const getICELoadDatasetView = async (
  payload: ICEDatasetTilePageReqPayload
): Promise<{totalDatasetCount: number}> => {
  const {data} = await apiClient.post(
    ingestionEndpoint('ice/loaddatasetview'),
    payload
  );
  return data;
};

export const postIngestionCopy = async (
  payload: IIngestionCopyRequest
): Promise<IIngestionCopyResponse> => {
  const {data} = await apiClient.post<IIngestionCopyResponse>(
    ingestionEndpoint('ingestion/copy'),
    payload
  );
  return data;
};

export const postIngestionEdit = async (
  payload: IIngestionCopyRequest
): Promise<IIngestionCopyResponse> => {
  const {data} = await apiClient.post<IIngestionCopyResponse>(
    ingestionEndpoint('ingestion/edit'),
    payload
  );
  return data;
};

export const getApoList = async (
  payload: IApoListRequest
): Promise<IApoListResponse> => {
  const {data} = await apiClient.post<IApoListResponse>(
    ingestionEndpoint('ingestion/apo/view'),
    payload
  );
  return data;
};

export const ApoRefreshSubmit = async (): Promise<boolean> => {
  try {
    const {data} = await apiClient.post<boolean>(
      ingestionEndpoint('ingestion/apo-updates/refresh-apo'),
    );
    return data;
  } catch (error) {
    throw parseApiError(error as AxiosError<BackendErrorData>, 'Ingestion');
  }
};

export const getApoProgress = async (): Promise<IApoProgressApiResponse> => {
  const {data} = await apiClient.get<IApoProgressApiResponse>(
    ingestionEndpoint('ingestion/apo/progress-loader'),
  );
  return data;
};
